export default "{\n    \"label_one\": \"{{name}}\",\n    \"label_0\": \"Status\",\n    \"label_other\": \"{{count}} Statuses\"\n}\n"